import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

const app = createApp(App).use(store);
app.use(router, VueCookies)
app.mount("#app");